import AppInfoComponentModelBase from '../_generated/modelBases/app-info-component-model-base';

export default class AppInfoComponentModel extends AppInfoComponentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
